
import SocialFeed from '@/components/ui-custom/SocialFeed';

const CommunitySocialSection = () => {
  return (
    <section className="section-padding bg-section-alt">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="heading-lg mb-4">Connect With Our Community</h2>
          <p className="text-adv-darkGray max-w-2xl mx-auto">
            Follow our adventures on social media and become part of the story.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          <SocialFeed />
        </div>
      </div>
    </section>
  );
};

export default CommunitySocialSection;
